// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type ClassAndFareContextProperties = {
  return_number_of_details?: number;
  return_number_of_classes?: number;
  return_display_price?: string;
  return_is_best_value?: boolean;
  display_price: string;
  number_of_classes?: number;
  is_best_value?: boolean;
  number_of_details?: number;
  number_of_amenities?: number;
  return_number_of_amenities?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/class_and_fare_context/jsonschema/2-0-1';
export const classAndFareContextName = 'class_and_fare_context';
export class ClassAndFareContext extends BaseTrackingContext<ClassAndFareContextProperties> {
  constructor(properties: ClassAndFareContextProperties) {
    super(classAndFareContextName, schema, properties);
  }
}
